export default "<button\n    @click='onRecordButtonClicked'\n    :disabled='isRecording || isRendering'\n> Render the gif\n</button>";